// Configuration centrale du site : modifiez SITE_NAME ici pour renommer le site partout.
export const SITE_NAME = "Parieurs Sportifs";
export const SITE_TAGLINE = "Comprendre avant de jouer";
// Domaine définitif utilisé pour canonical, Open Graph, données structurées et sitemap.
export const BASE_URL = "https://parieurs-sportifs.fr";
export const CONTACT_EMAIL = "hello@parieurs-sportifs.fr";
export const JIS_PHONE = "09 74 75 13 13";
export const PREVENTION_TEXT =
  "Jouer comporte des risques : endettement, isolement, dépendance. Pour être aidé, appelez le 09 74 75 13 13 (appel non surtaxé).";

export const NAV = [
  {
    label: "Comprendre les paris",
    items: [
      { label: "Qu'est-ce qu'un pari sportif ?", to: "/comprendre/quest-ce-quun-pari-sportif" },
      { label: "Les cotes", to: "/comprendre/les-cotes" },
      { label: "Les types de paris", to: "/comprendre/les-types-de-paris" },
      { label: "Les combinés", to: "/combines" },
      { label: "Glossaire", to: "/comprendre/glossaire" },
      { label: "Erreurs et mythes", to: "/comprendre/erreurs-et-mythes" },
      { label: "Les maths du long terme", to: "/comprendre/les-maths-du-long-terme" },
    ],
  },
  {
    label: "Cadre légal",
    items: [
      { label: "L'ANJ", to: "/cadre-legal/anj" },
      { label: "Site légal ou illégal ?", to: "/cadre-legal/site-legal-ou-illegal" },
      { label: "Les règles du joueur", to: "/cadre-legal/regles-du-joueur" },
      { label: "Fiscalité des gains", to: "/cadre-legal/fiscalite-des-gains" },
    ],
  },
  {
    label: "Comment ça fonctionne",
    items: [
      { label: "S'inscrire pas à pas", to: "/demarrer/sinscrire-pas-a-pas" },
      { label: "Dépôts et retraits", to: "/demarrer/depots-et-retraits" },
      { label: "Bonus de bienvenue", to: "/demarrer/bonus-de-bienvenue" },
    ],
  },
  { label: "Jeu responsable", to: "/jeu-responsable" },
  {
    label: "À propos",
    items: [
      { label: "À propos", to: "/a-propos" },
      { label: "Contact", to: "/contact" },
      { label: "Mentions légales", to: "/mentions-legales" },
      { label: "Confidentialité", to: "/confidentialite" },
      { label: "Cookies", to: "/cookies" },
    ],
  },
];
